// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Order_componentWrapper__0A3iH","company":"Order_company__oLKmT","title":"Order_title__Ad2uN","label":"Order_label__Uvf03"};